import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { ModalTypes } from 'src/app/core/helpers/modal-store'
import { ApiService } from 'src/app/core/services/api.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { scrollModalToTop } from '../options-utils/modal-shared'
import { SharedDataService } from '../../../../core/services/shared-data.service'

@Component({
    selector: 'app-modal-options-straight-decline',
    templateUrl: './modal-options-straight-decline.component.html',
    styleUrls: ['./modal-options-straight-decline.component.scss'],
    standalone: false
})
export class ModalOptionsStraightDeclineComponent implements OnInit{

  @Input() breakpoints: any = [{}]
  @Input() loanAcctId: any = null
  @Input() mobileNumber = ''
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  homePageData: any = {}

  constructor(
    private api: ApiService,
    public pageNavigationService: PageNavigationService,
    public modalStateService: ModalStateService,
    public logger: NGXLogger,
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {

    api.getHomePage().subscribe((res: any) => {
      this.homePageData = res.data.attributes
    }, (error: any) => {
      console.error(error)
    })
  }


  closeAndSave() {
    this.closeModal()
    this.saveState()
  }

  saveState() {
    this.logger.info('saving state!!')
    this.modalStateService.pushToLocalStorage('externalLink', 'true')
    this.logger.info('this.layout')
    this.modalStateService.pushToLocalStorage('modalType', ModalTypes.straightDecline)
  }

  closeModal() {
    this.closeModalEvent.emit()
  }
  ngOnInit() {
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    // client code
    if (isPlatformBrowser(this.platformId)) {
      scrollModalToTop()
    }
  }



}
